export default __webpack_public_path__ + "static/media/logo-app2c.8534f4c2.svg";